import { Keyword } from 'src/modules/keywords/types';

/**
 * Whether another ACTIVE campaign already claims this keyword.
 *
 * Two live campaigns answering the same keyword means a contact gets whichever
 * one the backend picks, so the picker warns before adding one. The campaign
 * being edited is excluded — a keyword it already owns is not a conflict.
 */
export function isKeywordClaimedElsewhere(
  keywords: Keyword[],
  keywordId: string,
  currentCampaignId?: string,
): boolean {
  return keywords
    .filter(k => k && k.id === keywordId)
    .flatMap(k => k.campaigns || [])
    .some(c => c && c.id !== currentCampaignId && c.status === 'active');
}

/** `default` keywords are company-wide and never offered as a campaign trigger. */
export const isSelectableKeyword = (keyword: Keyword): boolean => keyword.type !== 'default';
